import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { State } from 'redux/initialState';
import { useTranslate } from 'hooks/useTranslate';
import { getAiUsage } from 'modules/ai/redux/aiActions';

import './AiUsageIndicator.scss';

type AiUsageIndicatorProps = {
  societyId: string;
};

const AiUsageIndicator: FC<AiUsageIndicatorProps> = ({ societyId }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const usage = useSelector((state: State) => state.ai?.usage);

  useEffect(() => {
    if (societyId) dispatch(getAiUsage(societyId) as any);
  }, [dispatch, societyId]);

  if (!usage || usage.limit == null) return null;

  const percent = usage.percent || 0;
  // eslint-disable-next-line no-nested-ternary
  const barClass = percent >= 100 ? 'is-exceeded' : percent >= 80 ? 'is-warning' : 'is-ok';

  const formatter = new Intl.NumberFormat('es-ES');

  return (
    <div className="ai-usage-indicator">
      <div className="ai-usage-indicator__label">
        {t('AI_UsageThisMonth')}:{' '}
        <strong>{formatter.format(usage.used || 0)}</strong>
        {' / '}
        <span>{formatter.format(usage.limit || 0)}</span> {t('AI_Tokens')}
      </div>
      <div className={`ai-usage-indicator__bar ${barClass}`}>
        <div
          className="ai-usage-indicator__fill"
          style={{ width: `${Math.min(100, percent)}%` }}
        />
      </div>
    </div>
  );
};

export default AiUsageIndicator;
